'use client';

import { c as _c } from "react/compiler-runtime";
import { useOnboardingRecheck } from '@/features/onboarding/hooks/use-onboarding-recheck';
import type React from 'react';

/** Runs the onboarding's start-up checks in the background of the app, see the hook. */
export const OnboardingRecheck: React.FC = () => {
  const $ = _c(1);
  useOnboardingRecheck();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <></>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};